import OptionList from './OptionList.view';

export default OptionList;
